import { render, staticRenderFns } from "./PendingCardsReportTable.vue?vue&type=template&id=7ff63e18&scoped=true&"
import script from "./PendingCardsReportTable.vue?vue&type=script&lang=js&"
export * from "./PendingCardsReportTable.vue?vue&type=script&lang=js&"
import style0 from "./PendingCardsReportTable.vue?vue&type=style&index=0&id=7ff63e18&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff63e18",
  null
  
)

export default component.exports